<template>
  <!-- 注：Layout 只会在服务端被渲染，不要在此运行客户端有关逻辑 -->
  <!-- 页面初始化数据注入内容已经过 serialize-javascript 转义 防止 xss -->
  <html>
    <head>
      <meta charSet="utf-8">
      <meta v-if="!isMobileBrowser" name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
      <meta v-if="isMobileBrowser" name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no">
      <meta name="theme-color" content="#000000">
      <!-- favicon 自动拿public/favicon.ico，这里不用写 -->
      <ga-script v-if="isMicro" />
      <gtag-script v-if="isMicro" />
      <slot name="cssInject" />
      <slot name="viteClient" />
      <!-- 用于通过配置插入自定义的 script 为了避免影响期望功能这块内容不做 escape，为了避免 xss 需要保证插入脚本代码的安全性  -->
      <slot name="customeHeadScript" />
      <desktop-script />
      <mobile-script />
      <compatible-script />
      <meta name="description" :content="description">
      <title>{{ title }}</title>
      <ShareMetaInfo v-if="shareMetaInfo" :shareMetaInfo="shareMetaInfo" />
      <Favicon />
    </head>
    <body :class="{ 'rtl--container': isArSite }">
      <div id="app">
        <slot name="children" />
      </div>
      <slot name="initialData" />
      <slot name="customeFooterScript" />
      <slot name="jsInject" />
    </body>
  </html>
</template>

<script src="./index.ts" lang="ts"></script>
<style lang="less">
@import './index.less';

</style>
